import * as types from "../actionTypes";

export const getSummary = (pageNumber = null) => {
  return {
    type: types.MANAGER_GET_HASHTAG_SUMMARY_REQUEST,
    pageNumber
  };
};

export const getSummarySuccess = data => {
  return {
    type: types.MANAGER_GET_HASHTAG_SUMMARY_SUCCESS,
    payLoad: data
  };
};
export const getSummaryFailure = () => {
  return {
    type: types.MANAGER_GET_HASHTAG_SUMMARY_FAILURE
  };
};

export const getAllUsed = () => {
  return {
    type: types.MANAGER_GET_ALL_HASHTAG_USED_REQUEST
  };
};

export const getAllUsedSuccess = data => {
  return {
    type: types.MANAGER_GET_ALL_HASHTAG_USED_SUCCESS,
    payLoad: data
  };
};
export const getAllUsedFailure = error => {
  return {
    type: types.MANAGER_GET_ALL_HASHTAG_USED_FAILURE,
    error: error
  };
};
